<template>
	<chat-avatar-modal
		ref="$avatarModal"
		:title="$t('chat_avatar_upload')"
		@save="conferenceImg = $event"
	/>
	<div class="create-dialog-panel">
		<app-loader
			v-if="!users || loading"
			:style="loaderStyle"
		/>
		<div class="create-dialog-panel__header">
			<template v-if="selectedPersonsIds.length < 3">
				<div class="create-dialog-panel__header-photo">
					<template v-if="selectedPersonsIds.length === 1">
						<img
							v-if="selectedPersonsArray[0]?.Worker?.PhotoLink"
							:src="resolvePhotoUrl(selectedPersonsArray[0]?.Worker?.PhotoLink)"
							alt="photo"
						/>
						<img
							v-else-if="selectedPersonsArray[0]?.PhotoLink"
							:src="resolvePhotoUrl(selectedPersonsArray[0]?.PhotoLink)"
							alt="photo"
						/>
						<div
							v-else-if="selectedPersonsArray[0]?.Worker"
							class="create-dialog-panel__header-photo-liter"
						>
							{{ selectedPersonsArray[0]?.Worker.PhotoLiter }}
						</div>
						<div
							v-else
							class="create-dialog-panel__header-photo-liter"
						>
							{{ selectedPersonsArray[0]?.PhotoLiter }}
						</div>
					</template>
					<template v-else-if="selectedPersonsIds.length === 2">
						<img
							v-if="selectedPersonsArray[1]?.Worker?.PhotoLink"
							:src="resolvePhotoUrl(selectedPersonsArray[1]?.Worker?.PhotoLink)"
							alt="photo"
						/>
						<img
							v-else-if="selectedPersonsArray[1]?.PhotoLink"
							:src="resolvePhotoUrl(selectedPersonsArray[1]?.PhotoLink)"
							alt="photo"
						/>
						<div
							v-else-if="selectedPersonsArray[1]?.Worker"
							class="create-dialog-panel__header-photo-liter"
						>
							{{ selectedPersonsArray[1]?.Worker.PhotoLiter }}
						</div>
						<div
							v-else
							class="create-dialog-panel__header-photo-liter"
						>
							{{ selectedPersonsArray[1]?.PhotoLiter }}
						</div>
					</template>
				</div>
				<div class="create-dialog-panel__header-body">
					<div class="create-dialog-panel__header-body-name">
						{{ getUserName(selectedPersonsIds.length === 1 ? 0 : 1) }}
					</div>
					<div class="create-dialog-panel__header-body-buttons">
						<span
							class="create-dialog-panel__btn"
							@click="onBackToChatList"
						>
							{{ $t('cancel_short') }}
						</span>
							<span
								v-if="selectedPersonsIds.length === 1"
								class="create-dialog-panel__btn"
								@click="createChatWithYouOrOneFriend(0)"
							>
							{{ $t('ui_go') }}
						</span>
							<span
								v-else-if="selectedPersonsIds.length === 2"
								class="create-dialog-panel__btn"
								@click="createChatWithYouOrOneFriend(1)"
							>
							{{ $t('chat_go_to') }}
						</span>
					</div>
				</div>
			</template>
			<template v-else>
				<div
					class="create-dialog-panel__header-photo"
					@click="$avatarModal.onOpen()"
				>
					<template v-if="conferenceImg">
						<img
							:src="conferenceImgUrl"
							alt="photo"
						/>
					</template>
					<template v-else>
						<div class="create-dialog-panel__header-photo-conference">
							<app-icon
								class="create-dialog-panel__header-photo-conference-icon"
								name="photo-add"
								width="30px"
								color="#979797"
								hover-color="#3F884F"
								cursor="pointer"
							/>
						</div>
					</template>
				</div>
				<div class="create-dialog-panel__header-body">
					<div class="create-dialog-panel__header-body-name">
						<file-input
							ref="$inputRef"
							v-if="isConferenceNameEdited"
							v-model="conferenceName"
							@blur="isConferenceNameEdited = false"
						/>
						<template v-else>
							{{ conferenceName }}
							<app-tooltip :text="$t('edit_label')">
								<template #activator>
									<app-icon
										v-if="!isConferenceNameEdited"
										name="edit-pencil"
										size="18px"
										color="#979797"
										hover-color="#499259"
										cursor="pointer"
										@click="editConferenceName"
									/>
								</template>
							</app-tooltip>
						</template>
					</div>
					<div class="create-dialog-panel__header-body-buttons">
						<span
							class="create-dialog-panel__btn"
							@click="onBackToChatList"
						>
							{{ $t('cancel_short') }}
						</span>
						<span
							class="create-dialog-panel__btn"
							@click="createConference"
						>
							{{ $t(mode === 'edit-chat' ? (editedChat.IsPersonal ? 'chat_convert_to_group' : 'save') : 'chat_create_group') }}
						</span>
					</div>
				</div>
				<div
					v-if="editModel"
					class="create-dialog-panel__header-exit"
					@click.stop="exitChat"
				>
					<app-icon
						class="create-dialog-panel__header-exit-icon"
						name="logout"
						width="16px"
						color="#D05A4F"
						:title="$t('chat_leave_group')"
					/>
					{{ $t('chat_leave_group') }}
				</div>
			</template>
		</div>
		<div class="create-dialog-panel__search">
			<div class="create-dialog-panel__search-field">
				<div class="create-dialog-panel__search-field-label">
					{{ $t('chat_members') }}
				</div>
				<app-input
					class="create-dialog-panel__search-field-input"
					v-model="searchText"
					:placeholder="$t('search_short')"
					show-search-button
				/>
			</div>
			<div class="create-dialog-panel__search-field-divider" />
			<div class="create-dialog-panel__search-persons">
				<div
					v-if="listItemsCount"
					class="search-persons__group"
				>
					<div
						:class="{
							'search-persons__group-item': true,
							'search-persons__group-item--select-all': true
						}"
						@click="toggleAllPersons(null, true)"
					>
						<div class="search-persons__group-name">
							{{ $t('all_users') }}
						</div>
						<app-checkbox
							text=""
							:value="selectAll"
							@input="toggleAllPersons($event)"
							@click.stop
						/>
					</div>
				</div>
				<template v-if="listItemsCount">
					<div
						v-for="group in users"
						class="search-persons__group"
						:key="group.Position"
					>
						<div
							v-if="!group.Department && isShowSingleUser(group)"
							:class="{
								'search-persons__group-item': true,
								'search-persons__group-item--single': true
							}"
							@click="togglePerson(group.Worker.Id)"
						>
							<div class="search-persons__group-item-cred">
								<img
									v-if="group.Worker?.PhotoLink || group.PhotoLink"
									class="search-persons__group-item-cred-img"
									:src="resolvePhotoUrl(group.Worker ? group.Worker.PhotoLink : group.PhotoLink)"
									alt="Avatar"
								/>
								<div
									v-else
									class="search-persons__group-item-cred-photo"
								>
									{{ group.Worker?.PhotoLiter || group.PhotoLiter}}
								</div>
								<div
									class="search-persons__group-item-cred-name"
									v-html="highlightText(group.Worker?.Name || group.Name)"
								/>
							</div>
							<app-checkbox
								text=""
								:value="selectedPersonsIds.includes(group.Worker?.Id || group.Id)"
								:disabled="group.Worker?.AlwaysSelected || group.AlwaysSelected"
								@input="togglePerson(group.Worker?.Id || group.Id)"
								@click.stop
							/>
						</div>
						<div
							v-else-if="isShowDepartmentUsers(group)"
							class="search-persons__group-list"
						>
							<div
								:class="{
									'search-persons__group-item': true,
									'search-persons__group-item--select-all': true
								}"
								@click="toggleGroupPersons(group, $event, true)"
							>
								<div class="search-persons__group-name">
									{{ group.Department.Name }}
								</div>
								<app-checkbox
									text=""
									:value="allUsersFromGroupSelected(group)"
									@input="toggleGroupPersons(group, $event)"
									@click.stop
								/>
							</div>
							<template
								v-for="person in group.Department?.Workers"
								:key="person.Id"
							>
								<div
									v-if="isShowDepartmentUser(person)"
									class="search-persons__group-item"
									@click="togglePerson(person.Id)"
								>
									<div class="search-persons__group-item-cred">
										<img
											v-if="person.PhotoLink"
											class="search-persons__group-item-cred-img"
											:src="resolvePhotoUrl(person.PhotoLink)"
											alt="Avatar"
										/>
										<div
											v-else
											class="search-persons__group-item-cred-photo"
										>
											{{ person.PhotoLiter }}
										</div>
										<div
											class="search-persons__group-item-cred-name"
											v-html="highlightText(person.Name)"
										/>
									</div>
									<app-checkbox
										text=""
										:value="selectedPersonsIds.includes(person.Id)"
										:disabled="person.AlwaysSelected"
										@input="togglePerson(person.Id)"
										@click.stop
									/>
								</div>
							</template>
						</div>
					</div>
				</template>
				<div
					v-if="users && !listItemsCount"
					class="search-persons__empty-results"
				>
					{{ $t('nothing_found') }}
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import {
	computed,
	nextTick,
	onMounted,
	ref,
	watch
} from 'vue';
import {
	ChatUser,
	UserWorker
} from "@/store/chats";
import { headerStore } from "@/store/header";
import AppLoader from "@/components/common/AppLoader.vue";
import ChatAvatarModal from "@/components/main/chat-panel/modals/ChatAvatarModal.vue";
import AppInput from "@/components/ui-kit/input/AppInput.vue";
import AppCheckbox from "@/components/ui-kit/checkbox/AppCheckbox.vue";
import FileInput from "@/components/file/FileInput.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import { highlightSearchText } from "@/utils/textHelpers";
import { resolvePhotoUrl } from "@/utils/urlHelpers";
import { ChatsApi } from "@/ api/ChatsApi";
import { workerStore } from "@/store/worker";

const store = headerStore()
const userStore = workerStore()

const $inputRef = ref<InstanceType<typeof FileInput> | null>(null);
const $avatarModal = ref<typeof ChatAvatarModal | null>(null)
const loading = ref(false);
const searchText = ref("")
const conferenceImg = ref<string | null>(null)

const DEFAULT_CONFERENCE_NAME = "Новая беседа"
const conferenceName = ref(DEFAULT_CONFERENCE_NAME)
const isConferenceNameEdited = ref(false)
const selectAll = ref(false)
const selectedPersonsIds = ref<number[]>([])
const editModel = ref()

const selectedPersonsArray = computed(() =>
	selectedPersonsIds.value
		.map(id => findUser(id))
		.filter(user => !!user))

const conferenceImgUrl = computed(() =>
	conferenceImg.value
		? !conferenceImg.value.includes('https')
			? `${process.env.VUE_APP_API_OLD_URL}/${conferenceImg.value}`
			: conferenceImg.value
		: ""
)

const chatUsers = computed(() => store.getChatUsers)
const users = computed(() => {
	if (mode.value === 'edit-chat'  && !editedChat.value?.IsPersonal) {
		return [
			...editModel.value?.ExistingWorkers.map(worker =>
				worker.Id === currentUser.value?.Id
					? { ...worker, AlwaysSelected: true }
					: worker
			) || [],
			...chatUsers.value || []
		]
	}

	return chatUsers.value
})
const mode = computed(() => store.getChatMode)
const editedChat = computed(() => store.getEditedChat)
const currentUser = computed(() => userStore.workerProfile)

const listItemsCount = computed(() => {
	if (!users.value) return 0

	let count  = 0
	users.value.forEach(user => {
		if (!user.Department) {
			if (user.Worker) {
				if (user.Worker.Name.toUpperCase().includes(searchText.value.toUpperCase())) {
					count += 1
				}
			} else {
				if (user.Name.toUpperCase().includes(searchText.value.toUpperCase())) {
					count += 1
				}
			}
		} else {
			user.Department.Workers.forEach(worker => {
				if (worker.Name.toUpperCase().includes(searchText.value.toUpperCase())) {
					count += 1
				}
			})
		}
	})

	return count
})

watch(chatUsers, (newVal) => {
	if (newVal) {
		newVal.forEach(person => {
			if (!person.Department) {
				if (person.Worker.AlwaysSelected) {
					selectedPersonsIds.value.push(person.Worker.Id)
				}
			} else {
				person.Department.Workers.forEach(worker => {
					if (worker.AlwaysSelected) {
						selectedPersonsIds.value.push(worker.Id)
					}
				})
			}
		})

		if (mode.value === 'edit-chat' && !editedChat.value?.IsPersonal) {
			editModel.value.ExistingWorkers.forEach(person => {
				if (person.AlwaysSelected) {
					selectedPersonsIds.value.push(person.Id)
				}
			})
		}
	}
})

const togglePerson = (id: number) => {
	if (selectedPersonsIds.value.includes(id)) {
		selectedPersonsIds.value.splice(selectedPersonsIds.value.indexOf(id), 1)
	} else {
		selectedPersonsIds.value.push(id)
	}
}

const toggleAllPersons = (state: boolean, force?: boolean) => {
	const newState = force ? !selectAll.value : state
	if (newState) {
		selectAll.value = true
		const allPersons: number[] = []
		users.value?.forEach(person => {
			if (!person.Department) {
				allPersons.push(person.Worker ? person.Worker.Id : person.Id)
			} else {
				person.Department.Workers.forEach(worker => {
					allPersons.push(worker.Id)
				})
			}
		})

		selectedPersonsIds.value = allPersons
	} else {
		selectAll.value = false
		const alwaysSelectedUsers: number[] = []
		users.value?.forEach(person => {
			if (!person.Department) {
				if (person.Worker?.AlwaysSelected) {
					alwaysSelectedUsers.push(person.Worker.Id)
				} else if (person.AlwaysSelected) {
					alwaysSelectedUsers.push(person.Id)
				}
			} else {
				person.Department.Workers.forEach(worker => {
					if (worker.AlwaysSelected) {
						alwaysSelectedUsers.push(worker.Id)
					}
				})
			}
		})

		selectedPersonsIds.value = alwaysSelectedUsers
	}
}

const allUsersFromGroupSelected = (group: ChatUser) => {
	if (group.Department) {
		const selectedWorkers = group.Department.Workers.filter(worker => selectedPersonsIds.value.includes(worker.Id))
		return selectedWorkers.length === group.Department.Workers.length
	} else {
		return false
	}
}

const toggleGroupPersons = (group: ChatUser, state: boolean, force?: boolean) => {
	const newState = force ? !allUsersFromGroupSelected(group) : state
	if (newState) {
		group.Department?.Workers.forEach(worker => {
			if (!selectedPersonsIds.value.includes(worker.Id)) {
				selectedPersonsIds.value.push(worker.Id)
			}
		})
	} else {
		group.Department?.Workers.forEach(worker => {
			if (selectedPersonsIds.value.includes(worker.Id) && !worker.AlwaysSelected) {
				selectedPersonsIds.value.splice(selectedPersonsIds.value.indexOf(worker.Id), 1)
			}
		})
	}
}

const editConferenceName = () => {
	isConferenceNameEdited.value = true
	nextTick(() => $inputRef.value.focus())
}

const isShowSingleUser = (group: ChatUser) => {
	return group.Worker
		? group.Worker.Name.toUpperCase().includes(searchText.value.toUpperCase())
		: group.Name.toUpperCase().includes(searchText.value.toUpperCase())
}
const isShowDepartmentUser = (group: UserWorker) => {
	return group.Name.toUpperCase().includes(searchText.value.toUpperCase())
}

const isShowDepartmentUsers = (group: ChatUser) => {
	return !!group.Department?.Workers.find(worker => worker.Name.toUpperCase().includes(searchText.value.toUpperCase()))
}

const highlightText = (name: string) => {
	return highlightSearchText(searchText.value, name)
}

const findUser = (id: number): ChatUser | UserWorker | null => {
	let searchedUser = null
	users.value?.forEach(user => {
		if (!user.Department) {
			if (user.Worker?.Id === id) {
				searchedUser = user
			} else if (user.Id === id) {
				searchedUser = user
			}
		} else {
			user.Department.Workers.forEach(worker => {
				if (worker.Id === id) {
					searchedUser = worker
				}
			})
		}
	})

	return searchedUser
}

const getUserName = (idx: number) => {
	return selectedPersonsArray.value[idx]?.Worker
		? selectedPersonsArray.value[idx]?.Worker.Name
		: selectedPersonsArray.value[idx]?.Name
}

const onBackToChatList = () => {
	store.setMode('list')
}

const createChatWithYouOrOneFriend = async (index: number) => {
	const user = findUser(selectedPersonsIds.value[index])
	try {
		if (user) {
			loading.value = true;
			const response = await ChatsApi.createChatWithYouOrOneFriend(user.Worker?.Id || user.Id)
			await store.updateDialogInList(getCurrentDate())
			store.addOpenedChatsHistory({
				Id: response.Id,
				Name: user?.Worker?.Name || user.Name,
				ScrollTop: 0
			});
			store.setMode('chat')
			await store.setOpenedChat(response.Id)
		}
	} catch (e) {
		console.error(e)
	} finally {
		loading.value = false;
	}
}

const createConference = async () => {
	try {
		loading.value = true;
		let response = {
			Id: editedChat.value?.Id
		};

		if (mode.value === 'edit-chat') {
			if (editedChat.value?.IsPersonal && selectedPersonsIds.value.length > 2) {
				response = await ChatsApi.convertPersonalChatToConference({
					name: conferenceName.value,
					photolink: conferenceImgUrl.value,
					workers: selectedPersonsIds.value,
					chatId: editedChat.value.Id
				})
			} else {
				const prevExistWorkers = editModel.value.ExistingWorkers.map(ew => ew.Id)
				await ChatsApi.editConference({
					name: conferenceName.value,
					photolink: conferenceImgUrl.value,
					chatId: editedChat.value?.Id as number,
					workersToAdd: selectedPersonsIds.value.filter(sp => !prevExistWorkers.includes(sp)),
					workerToRemove: prevExistWorkers.filter(worker => !selectedPersonsIds.value.includes(worker)),
				})
			}
		} else {
			response = await ChatsApi.createConferenceWithUsers({
				name: conferenceName.value,
				photolink: conferenceImgUrl.value,
				workers: selectedPersonsIds.value
			})
		}

		await store.updateDialogInList(getCurrentDate())
		store.addOpenedChatsHistory({
			Id: response.Id as number,
			Name: conferenceName.value,
			ScrollTop: 0
		});
		if (mode.value === 'edit-chat') {
			await store.setOpenedChat(editedChat.value?.Id as number, null, true)
		} else {
			await store.setOpenedChat(response.Id as number)
		}
		store.setMode('chat')
	} catch (e) {
		console.error(e)
	} finally {
		loading.value = false;
	}
}

const exitChat = async () => {
	try {
		loading.value = true;
		await ChatsApi.exitConference(editedChat.value?.Id as number)
		await store.updateDialogInList(getCurrentDate())
		store.setMode('list')
		store.setOpenedChat(null)
	} catch (e) {
		console.error(e)
	} finally {
		loading.value = false;
	}
}

const getCurrentDate = () => {
	const date = new Date();

	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');

	const hours = String(date.getHours()).padStart(2, '0');
	const minutes = String(date.getMinutes()).padStart(2, '0');
	const seconds = String(date.getSeconds()).padStart(2, '0');
	const milliseconds = String(date.getMilliseconds()).padStart(3, '0');

	return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
}

watch(conferenceName, (newVal) => {
	if (!newVal) {
		conferenceName.value = DEFAULT_CONFERENCE_NAME;
	}
})

const loaderStyle = computed(() => ({
	'background-color': 'rgba(255, 255, 255, 0.5)'
}))

onMounted(async () => {
	try {
		loading.value = true;
		if (mode.value === 'edit-chat' && !editedChat.value?.IsPersonal) {
			editModel.value = await ChatsApi.getChatSettings(editedChat.value?.Id!)
			conferenceImg.value = editModel.value.Photolink || null
			conferenceName.value = editModel.value.Name || null
			store.setChatUsers(editModel.value.PotentialWorkerHolders)
			selectedPersonsIds.value = editModel.value.ExistingWorkers.map(worker => worker.Id)
		} else {
			store.fetchChatUsers(mode.value === 'edit-chat'
				? editedChat.value?.Id
				: 0
			)
		}
	} catch (e) {
		console.error(e)
	} finally {
		loading.value = false;
	}
})
</script>

<style lang="scss" scoped>
.create-dialog-panel {
	display: flex;
	flex-direction: column;
	position: relative;
	height: 100%;
	max-height: 100%;

	&__btn {
		font-size: 14px;
		line-height: 18px;
		font-weight: 600;
		color: #979797;
		padding: 7px 16px;
		border-radius: 8px;
		cursor: pointer;

		&:hover {
			background-color: #F2F2F2;
		}
	}

	&__header {
		display: flex;
		align-items: center;
		position: relative;
		gap: 22px;
		padding: 12px 8px 8px;
		background-color: #fff;
		border-top-left-radius: 8px;
		border-top-right-radius: 8px;

		&-photo {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 54px;
			height: 54px;
			border-radius: 100%;
			overflow: hidden;
			background: #E6C15A;
			box-shadow: 1px 2px 4px 0 #3B3B3B40;
			cursor: pointer;

			&-liter {
				color: #fff;
				font-size: 24px;
				font-weight: 500;
			}

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}

			&-conference {
				display: flex;
				align-items: center;
				justify-content: center;
				border: 1px solid #979797;
				border-radius: 100%;
				height: 100%;
				width: 100%;
				background-color: #F2F2F2;
				box-shadow: 1px 2px 4px 0 #3B3B3B40;

				&:hover {
					border-color: #3F884F;

					.create-dialog-panel__header-photo-conference-icon {
						color: #3F884F !important;
					}
				}
			}
		}

		&-body {
			display: flex;
			flex-direction: column;

			&-name {
				display: flex;
				align-items: center;
				gap: 4px;
				height: 32px;
				font-size: 14px;
				line-height: 18px;
				font-weight: 500;
				color: #4D4D4D;
			}

			&-buttons {
				display: flex;
				align-items: center;
				height: 32px;
				margin-left: -16px;
			}
		}

		&-conference {
			display: flex;
			align-items: center;
			gap: 10px;
		}

		&-exit {
			display: flex;
			align-items: center;
			gap: 2px;
			position: absolute;
			right: 8px;
			top: 13px;
			color: #D05A4F;
			font-size: 14px;
			line-height: 18px;
			font-weight: 600;
			padding: 7px 16px;
			border-radius: 8px;
			cursor: pointer;

			&:hover {
				background-color: #D05A4F33;
			}

			&-icon {
				margin-top: -2px;
			}
		}

		.conference {
			&__logo {
				border-radius: 50%;
				background-color: #567CA3;
				height: 60px;
				width: 60px;
				cursor: pointer;
			}

			&__body {
				&-actions {
					display: flex;
					align-items: center;
					gap: 10px;
					margin-bottom: 4px;
				}

				&-input {
					height: 32px;
				}

				&::v-deep(.q-field__control) {
					height: 32px;
				}

				&::v-deep(.q-field__append) {
					height: 32px;
				}
			}
		}
	}

	&__search {
		display: flex;
		flex-direction: column;
		flex: 1;
		width: 100%;
		background-color: #fff;
		padding: 0 8px 8px 6px;
		border-bottom-left-radius: 8px;
		border-bottom-right-radius: 8px;
		overflow: auto;

		&-field {
			width: 100%;

			&-label {
				font-size: 14px;
				line-height: 18px;
				font-weight: 500;
				color: #4D4D4D;
				margin-bottom: 8px;
			}

			&-input {
				width: 100%;
			}

			&-divider {
				width: 100%;
				border-top: 1px solid #F2F2F2;
				margin: 8px 0;
			}
		}

		&-persons {
			display: flex;
			flex-direction: column;
			height: 100%;
			position: relative;
			overflow: auto;
			gap: 2px;

			.search-persons__group {
				display: flex;
				flex-direction: column;

				&-list {
					display: flex;
					flex-direction: column;
					gap: 2px;
					margin-bottom: 8px;
				}

				&-name {
					display: flex;
					align-items: center;
					height: 30px;
					font-size: 14px;
					line-height: 18px;
					font-weight: 500;
					color: #4D4D4D;
					margin-bottom: 2px;
				}

				&-item {
					display: flex;
					align-items: center;
					justify-content: space-between;
					border-radius: 5px;
					margin-left: 16px;
					padding: 0 2px;

					&:hover {
						background-color: #F6F6F6;
					}

					&--select-all {
						margin-left: 0;
					}

					&-cred {
						display: flex;
						align-items: center;
						gap: 8px;

						&-photo {
							display: flex;
							align-items: center;
							justify-content: center;
							height: 30px;
							min-width: 30px;
							max-width: 30px;
							background-color: #E6C15A;
							border-radius: 50%;
							color: #fff;
							font-size: 18px;
							line-height: 20px;
							text-transform: uppercase;
						}

						&-img {
							height: 30px;
							min-width: 30px;
							max-width: 30px;
							border-radius: 50%;
						}

						&-name {
							font-size: 14px;
							line-height: 18px;
							color: #4D4D4D;
						}
					}
				}
			}

			.search-persons__empty-results {
				display: flex;
				align-items: center;
				justify-content: center;
				color: #616161;
				font-size: 14px;
			}
		}
	}
}
</style>
